module.exports = __webpack_public_path__ + "img/zko4.37d93ae4.jpg";